var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40002 6.40039V1.40039C8.40002 1.13517 8.29467 0.88082 8.10713 0.693284C7.9196 0.505748 7.66524 0.400391 7.40002 0.400391C7.13481 0.400391 6.88045 0.505748 6.69292 0.693284C6.50538 0.88082 6.40002 1.13517 6.40002 1.40039V6.40039H1.40002C1.13481 6.40039 0.880454 6.50575 0.692918 6.69328C0.505381 6.88082 0.400024 7.13517 0.400024 7.40039C0.400024 7.66561 0.505381 7.91996 0.692918 8.1075C0.880454 8.29503 1.13481 8.40039 1.40002 8.40039H6.40002V13.4004C6.40002 13.6656 6.50538 13.92 6.69292 14.1075C6.88045 14.295 7.13481 14.4004 7.40002 14.4004C7.66524 14.4004 7.9196 14.295 8.10713 14.1075C8.29467 13.92 8.40002 13.6656 8.40002 13.4004V8.40039H13.4C13.6652 8.40039 13.9196 8.29503 14.1071 8.1075C14.2947 7.91996 14.4 7.66561 14.4 7.40039C14.4 7.13517 14.2947 6.88082 14.1071 6.69328C13.9196 6.50575 13.6652 6.40039 13.4 6.40039H8.40002Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd1);
export default __webpack_public_path__ + "static/media/add-1.5db9c0b883e2801ec0611fa8c2003da5.svg";
export { ForwardRef as ReactComponent };